import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { selectCompanyInfo } from '../../../companyAnalysis/common/header/companyInfo/store/slice'

const useGetOrganizationId = (orgId) => {
  const location = useLocation()

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const companyInfo = useSelector(selectCompanyInfo)

  return orgId || params.organizationId || companyInfo.organizationId
}

export default useGetOrganizationId
